'use client';
import { jsx } from 'react/jsx-runtime';
import { Children, cloneElement, isValidElement } from 'react';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

function _object_without_properties(e, r) {
    if (null == e) return {};
    var t, o, i = _object_without_properties_loose(e, r);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(o = 0; o < n.length; o++)t = n[o], !(r.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(e, t) && (i[t] = e[t]);
    }
    return i;
}
function _object_without_properties_loose(e, r) {
    if (null == e) return {};
    var t, o, i = {}, n = Object.keys(e);
    for(o = 0; o < n.length; o++)t = n[o], r.indexOf(t) >= 0 || (i[t] = e[t]);
    return i;
}
const AdaptiveCarouselSlidePickerThumbnails = renderWithRef('AdaptiveCarouselSlidePickerThumbnails', null, (n, l)=>{
    let { children: s } = n, p = _object_without_properties(n, [
        "children"
    ]);
    return jsx(RenderComp, {
        root: "div",
        forwardedRef: l,
        classNames: new Set([
            'swan-adaptive-carousel-slide-picker-thumbnails'
        ]),
        props: p,
        children: Children.map(s, (e, r)=>isValidElement(e) ? cloneElement(e, {
                index: r
            }) : null)
    });
});

export { AdaptiveCarouselSlidePickerThumbnails };
